import {
    ACTIVITY_PAUSED,
    PAUSE_BANNER_TITLE,
    PAUSE_BANNER_BODY,
} from "../lib/constants";

/**
 * Site-wide pause notice rendered above the sticky header on every
 * public page. Driven by the ACTIVITY_PAUSED flag in constants.js —
 * returns null when disabled, so the rest of the layout is unaffected.
 *
 * Behaviour:
 *  - Not sticky: scrolls away naturally as the user goes down.
 *  - Not a popup, not dismissable: stays in the flow and reappears
 *    if the user scrolls back to the top.
 *  - Marked as an aside region for assistive tech.
 */
export function PauseBanner() {
    if (!ACTIVITY_PAUSED) return null;
    return (
        <aside
            role="region"
            aria-labelledby="pause-banner-title"
            className="bg-[#0B132B] text-[#F9F9F8] border-b-2 border-[#1B4332]"
            data-testid="pause-banner"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-4 md:py-5">
                <p
                    id="pause-banner-title"
                    className="font-display text-sm md:text-base font-medium tracking-tight mb-1.5"
                >
                    {PAUSE_BANNER_TITLE}
                </p>
                <p className="text-sm md:text-[15px] text-[#F9F9F8]/85 leading-relaxed max-w-4xl">
                    {PAUSE_BANNER_BODY}
                </p>
            </div>
        </aside>
    );
}
